import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../Styles/EventPage.css";


/*
  Converted from the original PHP/HTML page.
  Image paths assume your images live in:
  E:\vanakkam\vanakkam\client\public\assets\images\...
  In React (CRA/Vite), anything inside /public is served from the root,
  so every image below is referenced as "/assets/images/xxx.png".
  If you use Vite and keep assets in src instead of public, swap these
  for imports.
*/

const IMG = "/assets";

export default function EventPage() {
   const navigate = useNavigate();
  /* ---------------- Countdown ---------------- */
  const [time, setTime] = useState({ days: "00", hours: "00", minutes: "00", seconds: "00" });
  const [circles, setCircles] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [eventStarted, setEventStarted] = useState(false);
 const partners = [
  {
    id: 1,
    name: "SILVER SPONSORS",
    logos: [
      { src: `${IMG}/Infoziant.png`, link: "https://infoziant.com" },
      { src: `${IMG}/good.png`, link: "https://www.goodfreshers.com/" },
      { src: `${IMG}/walk.png`, link: "https://www.walkzero.com/" },
       { src: `${IMG}/formula.png`, link: "https://formulahr.com/" },
       { src: `${IMG}/hire.png`, link: "https://www.hireglint.ai/", big: true },
    ],
  },

  // 👇 new small card added here, will render right after silver sponsors
  {
    id: 7,
    name: "ASSOCIATION PARTNER",
    logos: [{ src: `${IMG}/test_your.jpeg`, link: "https://example.com/newpartner" }],
  },

  { id: 2, name: "EXCLUSIVE PARTNER", logos: [{ src: `${IMG}/out.png`, link: "" }] },
  { id: 3, name: "VENUE PARTNER", logos: [{ src: `${IMG}/venue.jpeg`, link: "" }] },
  { id: 4, name: "KNOWLEDGE PARTNER", logos: [{ src: `${IMG}/dina_4.png`, link: "" }] },
  { id: 5, name: "MENTAL WELLNESS PARTNER", logos: [{ src: `${IMG}/dina_5.png`, link: "" }] },
  { id: 6, name: "MEDIA PARTNER", logos: [{ src: `${IMG}/dina_3.png`, link: "" }] },
];

  /* ---------------- Previous Events ---------------- */
const previousEvents = [
  {
    id: 1,
    image: `${IMG}/PE_HRC_26.png`,
    title: "India HR Confluence 2026",
    date: "August 29, 2026 - 9:30 AM",
    location: "Dr.N.G.P. Arts and Science College, Coimbatore",
  },
  {
    id: 2,
    image: `${IMG}/PE_LHRF_26.png`,
    title: "India’s Largest HR Festival 2026",
    date: "July 11, 2026 - 9:30 AM",
    location: "Chennai Trade Centre, Chennai",
  },
  {
    id: 3,
    image: `${IMG}/PE_HRC_25.png`,
    title: "HR Confluence 2025",
    date: "August 23, 2025 - 9:30 AM",
    location: "Chennai Trade Centre, Chennai",
  },
  {
    id: 4,
    image: `${IMG}/PE_HF_25.png`,
    title: "HR Festival 2025",
    date: "July 05, 2025 - 9:30 AM",
    location: "Chennai Trade Centre, Chennai",
  },
];

  

  return (
    <>
      {/* Previous Events */}
      <section className="prev-events-section">
        <div className="container">
          <h2 className="prev-events-heading">Previous Events</h2>
          <div className="prev-events-heading-line"></div>

          <div className="prev-events-grid">
            {previousEvents.map((ev) => (
              <div className="prev-event-card" key={ev.id}>
                <div className="prev-event-image">
                  <img
                    src={ev.image}
                    alt={ev.title}
                    onError={(e) => {
                      // Path/file mismatch debug helper — if this fires, the
                      // image failed to load from the given src. Check the
                      // exact filename + extension + case inside
                      // client/public/assets, then restart the dev server.
                      console.error("Image failed to load:", ev.image);
                      e.currentTarget.onerror = null;
                      e.currentTarget.style.display = "none";
                      e.currentTarget.parentElement.classList.add("prev-event-image-broken");
                    }}
                  />
                </div>
                <div className="prev-event-info">
                  <h3 className="prev-event-title">{ev.title}</h3>
            <div className="prev-event-meta">
                    <img src={`${IMG}/PE_icon_01.png`} alt="" className="prev-event-icon" />
                    <span>{ev.date}</span>
                  </div>
                  <div className="prev-event-meta">
                    <img src={`${IMG}/PE_icon_02.png`} alt="" className="prev-event-icon" />
                    <span>{ev.location}</span>
                  </div>
                  <button
                    className="prev-event-btn"
                    onClick={() => {
                      // Only the 1st card (India HR Confluence 2026) navigates
                      // to its dedicated page. The other cards keep the button
                      // but do NOT redirect anywhere.
                      if (ev.id === 1) {
                        navigate("/hrc2026");
                      } else {
                        document.getElementById("hero")?.scrollIntoView({ behavior: "smooth" });
                      }
                    }}
                  >
                    Know more
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

/* ---------------- Small reusable pieces ---------------- */

function CountdownItem({ label, value, offset, circleId }) {
  return (
    <div className="countdown-item">
      <div className="circle">
        <svg>
          <circle className="circle-bg" cx="65" cy="65" r="40"></circle>
          <circle
            className="circle-progress"
            cx="65"
            cy="65"
            r="40"
            id={circleId}
            style={{
              strokeDasharray: 2 * Math.PI * 40,
              strokeDashoffset: offset,
            }}
          ></circle>
        </svg>
        <div className="countdown-number">{value}</div>
      </div>
      <div className="countdown-label">{label}</div>
    </div>
  );
}

function StatCard({ iconClass, icon, number, label }) {
  return (
    <div className="stat-card">
      <div className="stat-top">
        <div className={iconClass}>
          <img src={`${IMG}/${icon}`} alt="Day" />
        </div>
        <div className="stat-number">{number}</div>
      </div>
      <div className="stat-text">
        <strong>{label}</strong>
      </div>
    </div>
  );
}

function HighlightCard({ img, title }) {
  return (
    <div className="highlight-card">
      <div className="highlight-image">
        <img src={`${IMG}/${img}`} alt={title} />
      </div>
      <div className="highlight-title">{title}</div>
    </div>
  );
}

function WhyPill({ icon, text }) {
  return (
    <div className="why-pill">
      <span className="why-icon">
        <img src={`${IMG}/${icon}`} alt="" />
      </span>
      <span className="why-text">{text}</span>
    </div>
  );
}

function SpeakerCard({ linkedin, photo, name, role, company }) {
  return (
    <div className="spk-card">
      <a href={linkedin} className="spk-linkedin" target="_blank" rel="noreferrer" aria-label={`${name} LinkedIn Profile`}>
        <img src={`${IMG}/speker_lin.png`} alt="LinkedIn" />
      </a>
      <div className="spk-photo">
        <img src={`${IMG}/${photo}`} alt="Speaker Name" />
      </div>
      <div className="spk-info">
        <h3 className="spk-name">{name}</h3>
        <p className="spk-role">{role}</p>
        <p className="spk-company">{company}</p>
      </div>
    </div>
  );
}